// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Points_shieldSvg = require("./assets/points_shield.svg");
var Congratulation_bgSvg = require("./assets/congratulation_bg.svg");

var step5Box = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.borderRadius(Css.px(10)),
        /* :: */[
          Css.boxShadow(/* Some */[Css.px(2)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(255, 191, 194, 0.29)),
          /* :: */[
            Css.boxSizing(Css.borderBox),
            /* :: */[
              Css.margin4(Css.px(10), Css.px(10), Css.px(20), Css.px(10)),
              /* :: */[
                Css.background(/* `linearGradient */[
                      616379637,
                      /* tuple */[
                        /* `deg */[
                          4995526,
                          180
                        ],
                        /* :: */[
                          /* tuple */[
                            0,
                            Css.hex("FFF8F9")
                          ],
                          /* :: */[
                            /* tuple */[
                              50,
                              Css.rgba(255, 255, 255, 0.0)
                            ],
                            /* :: */[
                              /* tuple */[
                                98,
                                Css.hex("FFF8F9")
                              ],
                              /* [] */0
                            ]
                          ]
                        ]
                      ]
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var step5BoxInner1 = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
        /* :: */[
          Css.padding2(Css.px(0), Css.px(16)),
          /* [] */0
        ]
      ]
    ]);

var step5BoxInner2 = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.background(/* `hex */[
                5194459,
                "FFFAFA"
              ]),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
            /* :: */[
              Css.padding2(Css.px(0), Css.px(10)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var middleText = Css.style(/* :: */[
      Css.margin2(Css.px(5), Css.px(0)),
      /* [] */0
    ]);

var step5BoxInner3 = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.position(/* relative */903134412),
            /* :: */[
              Css.marginTop(Css.px(20)),
              /* :: */[
                Css.marginBottom(Css.px(25)),
                /* :: */[
                  Css.paddingBottom(Css.px(20)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var congratsIcon = Css.style(/* :: */[
      Css.margin4(Css.px(4), Css.px(0), Css.px(20), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var pointsShield = Css.style(/* :: */[
      Css.margin2(Css.px(20), Css.px(0)),
      /* :: */[
        Css.position(/* absolute */-1013592457),
        /* :: */[
          Css.transform(/* `scale */[
                -120664438,
                /* tuple */[
                  1.6,
                  1.6
                ]
              ]),
          /* [] */0
        ]
      ]
    ]);

var pointsShieldH1 = Css.style(/* :: */[
      Css.margin4(Css.px(68), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* :: */[
          Css.lineHeight(1.0),
          /* [] */0
        ]
      ]
    ]);

var pointsShieldH3 = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* :: */[
          Css.lineHeight(1.0),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* step5Box */step5Box,
  /* step5BoxInner1 */step5BoxInner1,
  /* step5BoxInner2 */step5BoxInner2,
  /* middleText */middleText,
  /* step5BoxInner3 */step5BoxInner3,
  /* congratsIcon */congratsIcon,
  /* pointsShield */pointsShield,
  /* pointsShieldH1 */pointsShieldH1,
  /* pointsShieldH3 */pointsShieldH3
];

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("Counter");

function make(points, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: step5Box
                }, React.createElement("div", {
                      className: step5BoxInner1
                    }, React.createElement("img", {
                          className: congratsIcon,
                          alt: "Congratulations",
                          src: Congratulation_bgSvg
                        })), React.createElement("div", {
                      className: step5BoxInner2
                    }, React.createElement("h2", {
                          className: middleText
                        }, "Du hast  dein  Workout\n            erfolgreich absolviert."), React.createElement("h2", {
                          className: middleText
                        }, "\n               Dein aktueller Punktestand:")), React.createElement("div", {
                      className: step5BoxInner3
                    }, React.createElement("img", {
                          className: pointsShield,
                          alt: "pointsShield",
                          src: Points_shieldSvg
                        }), React.createElement("h1", {
                          className: pointsShieldH1
                        }, "" + (String(points) + "")), React.createElement("h3", {
                          className: pointsShieldH3
                        }, "pts.")));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* step5Box Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/step5box.re
// module id = 125
// module chunks = 0